import { ArrowRight, Crown, Info } from "lucide-react";
import { fmt } from "@/lib/api";

/**
 * Compact promo strip on the regular PDP: shows the admin-set PRIME member
 * price for the selected variant and deep-links into PRIME mode.
 * Presentation only — pricing/eligibility stay server-side.
 */
export default function PrimePromoBanner({ primePrice, regularPrice, unit, hasVariants, onClick, testid = "prime-promo-banner" }) {
  const savings = Math.round((regularPrice - primePrice) * 100) / 100;
  if (!(primePrice > 0) || !(savings > 0)) return null;
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={onClick}
      className="group mt-3 flex w-full flex-col gap-3 rounded-2xl border border-[#E4B66D]/30 bg-[#242521] px-4 py-3.5 text-left transition-[border-color,box-shadow] duration-300 motion-reduce:transition-none hover:border-[#E4B66D]/60 hover:shadow-[0_8px_30px_-10px_rgba(228,182,109,0.35)] sm:flex-row sm:items-center sm:justify-between sm:gap-4"
    >
      <span className="flex items-center gap-3">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#E4B66D]/15">
          <Crown className="h-4 w-4 text-[#E4B66D]" />
        </span>
        <span className="text-xs font-semibold leading-snug text-[#F8F6F0]">
          Get this {hasVariants ? "variant" : "product"} for{" "}
          <span className="font-extrabold text-[#E4B66D]">{fmt(primePrice)}/{unit}</span> with PAQVERO PRIME
          <Info className="mb-0.5 ml-1.5 inline h-3 w-3 align-baseline text-[#A5A49A]" />
          <span className="ml-2 inline-flex items-center rounded-full bg-[#E4B66D]/15 px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-[#E4B66D]" data-testid={`${testid}-save`}>
            Save {fmt(savings)}
          </span>
        </span>
      </span>
      <span
        className="flex w-full items-center justify-center gap-1.5 rounded-full border border-[#E4B66D] px-4 py-2 text-[11px] font-extrabold uppercase tracking-[0.14em] text-[#E4B66D] transition-[background-color,color] duration-300 motion-reduce:transition-none group-hover:bg-[#E4B66D] group-hover:text-[#242521] sm:w-auto sm:shrink-0"
        data-testid={`${testid}-cta`}
      >
        View in Prime Store <ArrowRight className="h-3.5 w-3.5" />
      </span>
    </button>
  );
}
